<h4 mat-dialog-title>Error</h4>
<div mat-dialog-content>
  {{ data.message }}
</div>
<div mat-dialog-actions>
  <button class="btn btn-primary" (click)="onNoClick()" cdkFocusInitial>
    Ok
  </button>
</div>
